(() => {
  'use strict';
  const configNode = document.getElementById('kaartstudio-test-config');
  const catalogNode = document.getElementById('kaartstudio-product-catalog');
  if (!configNode || !catalogNode) return;
  const config = JSON.parse(configNode.textContent);

  // Stable template IDs; products, prices and artwork remain sourced from the
  // existing purchasable card catalog used by the editor and shopping cart.
  const groups = {
    recommended: ['61354322100558', '55267557572942', '55286135128398', '55267615998286', '61354103701838', '61354063298894', '55327872319822'],
    birthday: ['55267555803470', '55267615998286', '55267615539534', '55267571237198', '55267569140046', '55267617571150', '61354103701838', '55267536601422', '55267534897486', '55267578151246', '55267617309006', '55267538436430', '55267614851406', '55267562029390', '61459619643726', '55267616489806', '55267563012430', '61354103865678'],
    getwell: ['55286135128398', '55286135488846', '55286135095630', '61354195386702', '55286135521614', '55286135226702', '55286134899022', '55286135030094', '55286135390542', '61354195517774', '55286134964558', '55286135357774', '55286135292238', '55286134931790', '55286134997326', '55286135259470', '55286134866254', '55286135423310'],
    love: ['55327872057678', '55327872155982', '55327872090446', '55327872123214', '55327872188750', '55327872221518', '55327872254286', '55327872287054', '55327872319822', '55327872385358'],
    justbecause: ['61354322100558', '61354322231630', '55327872123214', '55267557572942', '55286134866254', '55327872155982', '55327872188750', '55327872385358'],
    thanks: ['61354062840142', '61354063003982', '61354063135054', '61354063298894', '61354063593806', '61354063724878', '61354063888718'],
    graduation: ['59844347396430', '59844347330894', '59844347593038', '59844347363662', '59844347494734', '59844347461966', '59844347691342', '59844347560270'],
    birth: ['61351600619854', '61351600783694', '61351600980302', '61351602192718', '61351602913614', '61351603634510', '61351603798350', '61351605109070']
  };
  const labels = {
    recommended: 'Aanbevolen', birthday: 'Verjaardag', getwell: 'Beterschap',
    love: 'Liefde', justbecause: 'Zomaar', thanks: 'Bedankt', graduation: 'Geslaagd', birth: 'Geboorte'
  };
  const catalog = new Map(JSON.parse(catalogNode.textContent)
    .filter(card => card.purchasable && card.variants?.A6 && card.width < card.height)
    .map(card => [String(card.templateId), card]));
  // Eigen ontwerp is available in every occasion, including the initial mix.
  if (catalog.has('blank')) {
    for (const key of Object.keys(groups)) {
      groups[key] = groups[key].filter(id => id !== 'blank' && catalog.has(id));
      // Recommended follows the supplied order; other occasions keep position six.
      groups[key].splice(key === 'recommended' ? 1 : 5, 0, 'blank');
    }
    groups.recommended = groups.recommended.slice(0, 8);
  }
  const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  function makeCard(card) {
    const node = document.createElement('div');
    node.className = 'addon-section__tab--product js-wizard-product-card';
    node.dataset.cardTemplate = card.templateId;
    node.dataset.price = card.variants.A6.price;
    const base = new URL('/catalog-artwork/' + card.version, config.origin).href;
    node.dataset.front = card.previewUrl || base + '-full.webp';
    node.dataset.imgSrc = card.previewUrl || base + '-512.webp';
    // This static structure is the same as the server-rendered card tiles.
    node.innerHTML = '<input type="hidden" name="id">' +
      '<div class="addon-section__tab--product-image" style="--aspect-ratio:0.707;position:relative">' +
      '<div class="rao-card-sheet kaartstudio-folded-card"><button type="button" class="rao-card-select"></button><img loading="lazy" decoding="async"></div></div>' +
      '<div class="addon-section__tab--product-content"><div class="addon-section__tab--product-content-upper">' +
      '<p class="addon-section__tab--product-title"></p></div>' +
      '<div class="addon-section__tab--product-content-bottom addon-section__tab--product-price"><price-list><sale-price class="text-subdued"></sale-price></price-list></div></div>';
    node.querySelector('input').value = card.variants.A6.id;
    node.querySelector('button').setAttribute('aria-label', 'Kies ' + card.title);
    node.querySelector('.addon-section__tab--product-title').textContent = card.title;
    node.querySelector('sale-price').textContent = money.format(card.variants.A6.price / 100);
    const image = node.querySelector('img');
    image.src = node.dataset.imgSrc;
    if (!card.previewUrl) image.srcset = base + '-512.webp 512w, ' + base + '-1024.webp 1024w';
    image.sizes = '(max-width: 767px) 45vw, (max-width: 1199px) 30vw, 350px';
    image.alt = card.title;
    image.width = card.width;
    image.height = card.height;
    if (card.version) image.dataset.artworkVersion = card.version;
    return node;
  }

  function applyFilter(wizard, tab, key) {
    const ids = groups[key];
    if (!ids) return;
    tab.dataset.cardOccasion = key;
    const grid = tab.querySelector('.addon-section__tab--products');
    const cards = Array.from(grid.querySelectorAll('[data-card-template]'));
    for (const card of cards) card.hidden = !ids.includes(card.dataset.cardTemplate);
    // Keep all nodes (and native selection handlers), only reorder the matching
    // cards. Changing a filter never changes the customer's selected card.
    for (const id of ids) {
      const card = cards.find(item => item.dataset.cardTemplate === id);
      if (card) grid.append(card);
    }
    tab.querySelectorAll('[data-card-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.cardFilter === key));
    });
    wizard.showTabProducts(tab);
    const count = cards.filter(card => !card.hidden).length;
    tab.querySelector('.kaartstudio-occasion-status').textContent = labels[key] + ': ' + count + ' kaarten';
  }

  function prepare(wizard) {
    const tab = wizard.querySelector('.addon-section--tab[data-index="0"][data-card-occasion-filters]');
    if (!tab || tab.hasAttribute('data-card-occasion-ready')) return false;
    const grid = tab.querySelector('.addon-section__tab--products');
    if (!grid) return false;
    const existing = grid.querySelectorAll('.js-wizard-product-card');
    if (tab.dataset.cardOccasionFilters === 'empty' && existing.length) return false;
    const ids = [...new Set(Object.values(groups).flat())].filter(id => catalog.has(id));
    if (!ids.length) return false;
    existing.forEach(card => card.remove());
    const fragment = document.createDocumentFragment();
    ids.forEach(id => fragment.append(makeCard(catalog.get(id))));
    grid.append(fragment);
    const filters = document.createElement('div');
    filters.className = 'kaartstudio-occasion-filters';
    filters.setAttribute('role', 'group');
    filters.setAttribute('aria-label', 'Kies een gelegenheid');
    for (const [key, label] of Object.entries(labels)) {
      if (!groups[key].some(id => catalog.has(id))) continue;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.cardFilter = key;
      button.textContent = label;
      button.addEventListener('click', () => applyFilter(wizard, tab, key));
      filters.append(button);
    }
    const status = document.createElement('span');
    status.className = 'kaartstudio-occasion-status';
    status.setAttribute('role', 'status');
    grid.before(filters, status);
    tab.dataset.cardOccasionReady = 'true';
    applyFilter(wizard, tab, 'recommended');
    return true;
  }

  function addOwnDesign(wizard) {
    const own = catalog.get('blank');
    const tab = wizard.querySelector('.addon-section--tab[data-index="0"]');
    const grid = tab?.querySelector('.addon-section__tab--products');
    if (!own || !grid || grid.querySelector('[data-card-template="blank"]')) return false;
    const cards = grid.querySelectorAll('.js-wizard-product-card');
    grid.insertBefore(makeCard(own), cards[5] || null);
    return true;
  }

  const addedBirthdayIds = ['61354103701838', '61354103865678', '61459619643726'];
  function addBirthdayCards(wizard) {
    const tab = wizard.querySelector('.addon-section--tab[data-index="0"][data-card-occasion-filters="empty"]');
    if (!tab || tab.hasAttribute('data-card-occasion-ready')) return false;
    const grid = tab.querySelector('.addon-section__tab--products');
    const existing = Array.from(grid?.querySelectorAll('.js-wizard-product-card') || []);
    const template = node => {
      const id = node.querySelector('input[name="id"]')?.value;
      return Array.from(catalog.values()).find(card => card.templateId === id || card.aliases?.includes(id))?.templateId;
    };
    const birthdayCards = existing.filter(node => template(node) !== 'blank');
    if (!birthdayCards.length || !birthdayCards.every(node => [...groups.birthday, '55267557572942'].includes(template(node)))) return false;
    const present = existing.map(template);
    const additions = addedBirthdayIds.filter(id => !present.includes(id) && catalog.has(id));
    additions.forEach(id => grid.append(makeCard(catalog.get(id))));
    const cards = Array.from(grid.querySelectorAll('.js-wizard-product-card'));
    const pig = cards.find(node => template(node) === '61354103701838');
    const position = !present.includes('blank') && catalog.has('blank') ? 6 : 7;
    const moved = pig && cards.indexOf(pig) !== position;
    if (moved) grid.insertBefore(pig, cards.filter(node => node !== pig)[position] || null);
    const ordered = Array.from(grid.querySelectorAll('.js-wizard-product-card'));
    const proost = ordered.find(node => template(node) === '61459619643726');
    const proostPosition = !present.includes('blank') && catalog.has('blank') ? 14 : 15;
    const proostMoved = proost && ordered.indexOf(proost) !== proostPosition;
    if (proostMoved) grid.insertBefore(proost, ordered.filter(node => node !== proost)[proostPosition] || null);
    return additions.length > 0 || moved || proostMoved;
  }

  const addedGetwellIds = ['61354195386702', '61354195517774'];
  function addGetwellCards(wizard) {
    const tab = wizard.querySelector('.addon-section--tab[data-index="0"][data-card-occasion-filters="empty"]');
    if (!tab || tab.hasAttribute('data-card-occasion-ready')) return false;
    const grid = tab.querySelector('.addon-section__tab--products');
    const existing = Array.from(grid?.querySelectorAll('.js-wizard-product-card') || []);
    const template = node => {
      const id = node.querySelector('input[name="id"]')?.value;
      return Array.from(catalog.values()).find(card => card.templateId === id || card.aliases?.includes(id))?.templateId;
    };
    const cards = existing.filter(node => template(node) !== 'blank');
    if (!cards.length || !cards.every(node => groups.getwell.includes(template(node)))) return false;
    const missing = addedGetwellIds.filter(id => !cards.some(node => template(node) === id) && catalog.has(id));
    if (!missing.length) return false;
    const ordered = cards.filter(node => !addedGetwellIds.includes(template(node)));
    addedGetwellIds.forEach((id, index) => {
      if (!catalog.has(id)) return;
      const card = cards.find(node => template(node) === id) || makeCard(catalog.get(id));
      ordered.splice(index ? 9 : 3, 0, card);
    });
    const own = existing.find(node => template(node) === 'blank');
    if (own) ordered.splice(5, 0, own);
    grid.append(...ordered);
    return true;
  }

  customElements.whenDefined('addon-section').then(() => {
    const proto = customElements.get('addon-section').prototype;
    if (proto.__kaartstudioOccasionsInstalled) return;
    proto.__kaartstudioOccasionsInstalled = true;
    const show = proto.showTabProducts;
    proto.showTabProducts = function (tab) {
      if (!tab.hasAttribute('data-card-occasion-ready')) return show.call(this, tab);
      const cards = Array.from(tab.querySelectorAll('[data-card-template]')).filter(card => !card.hidden);
      const limit = window.innerWidth < 768 ? 6 : 16;
      cards.forEach((card, index) => card.classList.toggle('is-hidden-product', index >= limit));
      const more = tab.querySelector('.addon-section__tab--product-show-container');
      if (more) more.style.display = cards.length > limit ? 'block' : 'none';
    };
    const setup = proto.setupTabs;
    proto.setupTabs = function () {
      prepare(this);
      addBirthdayCards(this);
      addGetwellCards(this);
      addOwnDesign(this);
      return setup.apply(this, arguments);
    };
    const snapshot = proto.createReturnState;
    proto.createReturnState = function () {
      const state = snapshot.apply(this, arguments);
      state.cardOccasion = this.querySelector('[data-card-occasion-ready]')?.dataset.cardOccasion;
      return state;
    };
    const restore = proto.restoreReturnState;
    proto.restoreReturnState = function (state) {
      const restored = restore.apply(this, arguments);
      const tab = this.querySelector('[data-card-occasion-ready]');
      if (restored && tab && groups[state.cardOccasion]) applyFilter(this, tab, state.cardOccasion);
      return restored;
    };
    // Covers an already-open wizard if this deferred asset arrived late.
    document.querySelectorAll('addon-section').forEach(wizard => {
      const prepared = prepare(wizard);
      const addedBirthday = addBirthdayCards(wizard);
      const addedGetwell = addGetwellCards(wizard);
      const added = addOwnDesign(wizard);
      if (prepared || added || addedBirthday || addedGetwell) {
        const tab = wizard.querySelector('.addon-section--tab[data-index="0"]');
        // Bind only new nodes on an already-open wizard, preserving handlers on
        // the existing occasion-specific cards.
        const grid = tab.querySelector('.addon-section__tab--products');
        const ordered = Array.from(grid.children);
        const existing = ordered.filter(card => !card.hasAttribute('data-card-template'));
        existing.forEach(card => card.remove());
        wizard.handleProductSelection(tab);
        grid.append(...ordered);
        wizard.showTabProducts(tab);
      }
    });
  });
})();

